import React, { useEffect, useState } from 'react';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import { api } from '../../app/Api/ApiSlice';
import StoreFeedCard from '../../components/StoreFeedCard';
import './storesStyles.css';
import InfiniteScroll from 'react-infinite-scroll-component';

const FavouriteStores = () => {
    const [stores, setStores] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const fetchShops = async (pageNumber) => {
        try {
            setIsLoading(true);

            console.log('Fetching favourites, page:', pageNumber);

            const response = await api.get('/stores/favourites', {
                params: { page: pageNumber },
            });

            const newStores = response?.data?.data ?? [];

            if (newStores.length === 0) {
                setHasMore(false);
                return;
            }

            setStores((prev) => {
                const ids = new Set(prev.map((s) => s._id));
                const unique = newStores.filter((s) => !ids.has(s._id));
                return [...prev, ...unique];
            });
        } catch (error) {
            toast.error(
                error?.response?.data?.message || 'Failed to load stores'
            );
        } finally {
            setIsLoading(false);
        }
    };

    // ✅ Initial + paginated fetch
    useEffect(() => {
        fetchShops(page);
    }, [page]);

    const loadMore = () => {
        if (hasMore) {
            setPage((prev) => prev + 1);
        }
    };

    return (
        <div className="store-feeds page-body">
            <div className="stores-page-content">
                <div className="stores-page-header">
                    <h2 className="stores-page-title">Favourites</h2>
                </div>

                <InfiniteScroll
                    dataLength={stores.length}
                    next={loadMore}
                    hasMore={hasMore}
                    loader={<Loader />}
                    endMessage={<p>No more businesses available.</p>}
                >
                    <div className="stores-grid">
                        {stores.map((str) => (
                            <StoreFeedCard key={str._id} str={str} />
                        ))}
                    </div>
                </InfiniteScroll>

                {isLoading && stores.length === 0 && <Loader />}
            </div>
        </div>
    );
};

export default FavouriteStores;
